import React from 'react';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';

interface SliderProps {
  images: string[];
}

const Slider: React.FC<SliderProps> = ({ images }) => {
  const properties = {
    prevArrow: <button style={{ ...buttonStyle, left: '10px' }}><i className="uil uil-angle-left"></i></button>,
    nextArrow: <button style={{ ...buttonStyle, right: '10px' }}><i className="uil uil-angle-right"></i></button>,
    autoplay: true,
    indicators: true,
    transitionDuration: 500,
  };

  return (
    <div className="slider-container">
      <Slide {...properties}>
        {images.map((each, index) => (
          <div key={index} className="each-slide">
            <div className="slide-content">
              <img src={each} alt={`Slide ${index + 1}`} />
            </div>
          </div>
        ))}
      </Slide>
    </div>
  );
};

const buttonStyle = {
  width: "30px",
  height: "30px",
  background: 'rgba(255, 255, 255, 0.8)',
  border: '0px',
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 10,
  padding: 0,
  cursor: 'pointer',
  fontSize: '20px',
  color: '#333',
  lineHeight: '1',
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
};

export default Slider;
